<template>
  <div :isInvalid="isInvalid">
    <b-input
      ref="selectClick"
      class="select overflow-hidden pointer"
      :class="[{ 'disabled': isDisabled }, selected.length ? 'text-dark' : 'text-neutral']"
      :readonly="true"
      @click="handleShowPopup"
      :value="displayText"/>
    <div class="search-box position-relative">
      <div class="position-absolute openSearch py-3 pl-3 pr-2"
        ref="changeShow"
        v-show="showPopup">
        <div class="pr-2" v-if="!hideSearch">
          <input class="search form-control"
                 ref="search"
                 type="text"
                 v-model="search" placeholder="Buscar" />
        </div>
        <div ref='wrapList' :class="wrapCustomClass" class="wrap-list pl-1">
          <ul class="dados p-0 m-0">
            <li
              v-if="!hideDeselect
              && !this.$scopedSlots['customView']
              && selected.length > 0
              && !radio"
              class="py-2 px-3 search-box__deselect">
              <span class="pointer" @click="setAll()">(X) Limpar Selecionado(s)</span>
            </li>
            <li v-if="!radio && !this.$scopedSlots['customView']" class="py-2 px-3">
              <label class="container-check mb-0 d-flex align-items-center flex-wrap"
              :for="('all-' + search_critery)"
              :title="searchNameAll">
                <span
                  :class="{ 'checkmark--checked': all }"
                  class="checkmark"></span>
                <input
                  class="check-input"
                  type="checkbox"
                  @change="setAll(all)"
                  v-model="all"
                  :id="('all-' +  search_critery)"
                  />
                <b-col class="overflow-hidden pr-0">
                  <span>{{ searchNameAll }}</span>
                </b-col>
              </label>
            </li>

            <slot name="customView" :rows="filteredObject" :pickFunc="setSingle">
              <li class="py-2 px-3" v-for="(data, index) in filteredObject"
                  :key="index">
                <label class="search-box__item container-check mb-0 d-flex align-items-center"
                       :for="`_SB__${SB_ID}__${(index+search_critery)}`"
                       :title="data[searchCritery]">
                <span
                  :class="{ 'checkmark--checked': selected.includes(data), 'radio': radio }"
                  class="checkmark"></span>
                  <input type="hidden"
                         v-model="data.SB_ID"
                         :class="data.name_for"
                         v-on="setId(data)" />
                  <input
                    class="check-input"
                    :checked="selected.includes(data)"
                    type="checkbox"
                    @click="setSingle(data)"
                    :id="`_SB__${SB_ID}__${(index+search_critery)}`" />
                  <b-col class="overflow-hidden pr-0">
                    <span>{{ data[searchCritery] }}</span>
                  </b-col>
                </label>
              </li>
            </slot>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DOMUtils from '@/utils/DOMUtils';

let SB_ID_COUNT = 0;

export default {
  name: 'SearchBox',
  data() {
    return {
      search: '',
      search_critery: this.searchCritery,
      selected: [],
      all: false,
      showPopup: false,
      SB_ID: null,
    };
  },
  props: {
    searchCritery: String,
    isInvalid: Boolean,
    dataObject: [Object, Array],
    searchNameAll: String,
    value: [Object, Array, String],
    displayValue: String,
    idToSelectOptions: {
      type: String,
      default: 'id',
    },
    wrapCustomClass: {
      type: String,
      default: 'no-class',
    },
    radio: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Nenhum selecionado',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideDeselect: {
      type: Boolean,
      default: false,
    },
    hideSearch: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.showPopup = false;
      this.$refs.wrapList.scrollTop = 0;
      document.removeEventListener('click', this.handleClose);
    },
    handleClose(event) {
      if (!DOMUtils.isChildOf(event.target, this.$el)
      && !DOMUtils.classOrIdIn(event, ['preview'])) this.close();
    },
    handleShowPopup() {
      if (this.showPopup) {
        this.close();
      } else if (!this.isDisabled) {
        this.showPopup = true;
        this.$refs.wrapList.scrollTop = 0;
        document.addEventListener('click', this.handleClose);
      }
    },
    setAll(all) {
      this.selected = [];
      if (all) {
        for (let i = 0; i < this.dataObject.length; i += 1) {
          this.setItem(this.dataObject[i]);
        }
        this.showPopup = false;
      } else {
        this.all = false;
      }
      this.sendData();
    },
    setId(data) {
      const id = data[this.idToSelectOptions];
      const d = data;
      d.SB_ID = id;
    },
    removeItem(obj) {
      for (let i = 0; i < this.selected.length; i += 1) {
        if (this.selected[i].SB_ID === obj.SB_ID) {
          this.selected.splice(i, 1);
          break;
        }
      }
    },
    verifyItem(obj) {
      let findId = false;
      if (this.selected.length > 0) {
        for (let i = 0; i < this.selected.length; i += 1) {
          if (this.selected[i] === obj) {
            findId = true;
            break;
          }
        }
      }
      return findId;
    },
    setSingle(obj) {
      this.setItem(obj);
      this.all = this.dataObject.length > 0 && this.dataObject.length === this.selected.length;
      this.sendData();
    },
    setItem(obj) {
      if (this.radio || this.$scopedSlots.customView) {
        this.selected = [obj];
        this.close();
      } else if (this.verifyItem(obj) === false) {
        this.selected.push(obj);
      } else {
        this.removeItem(obj);
      }
    },
    sendData() {
      this.$emit('input', this.selectedValues);
      this.$emit('change', this.selectedValues);
      this.search = '';
    },

  },
  computed: {
    filteredObject() {
      return this.dataObject
        .filter(data => data[this.search_critery] !== undefined
         && data[this.search_critery]
           .toUpperCase()
           .match(this.search.toLocaleUpperCase()));
    },
    selectedValues() {
      return this.selected.map(options => options[this.idToSelectOptions]);
    },
    displayText() {
      if (this.selected.length > 1) {
        return `${this.selected.length} Selecionados`;
      }

      if (this.selected.length === 1) {
        return this.selected[0][this.displayValue];
      }

      return this.placeholder;
    },
    isDisabled() {
      return this.disabled || !this.dataObject || this.dataObject.length === 0;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.dataObject !== undefined) {
          this.selected = this.dataObject
            .filter(options => this.value.includes(options[this.idToSelectOptions]));
        }
      },
    },
  },
  created() {
    this.SB_ID = SB_ID_COUNT;
    SB_ID_COUNT += 1;
  },
};
</script>
<style lang="scss" scoped>
.openSearch{
  background-color: $bg-default;
  z-index: 2;
  width: 100%;
  transition: all .5s;
  @include box-shadow();
  input{
    @include border-dark();
    border-radius:0;
    background-image: url('~@/assets/glass.svg');
    background-repeat: no-repeat;
    background-position: 15px center;
    padding-left: 45px;
  }
}
.wrap-list{
  max-height: 200px;
  overflow: auto;
  @include rounded-gray-scroll();
}
.active{display: block;}
.dados{list-style: none;}
.dados li{
  border-bottom:1px solid $silver;
  display: block;
  &:last-child {
    border-bottom: none;
  }
}
.select {
  @include border-dark();
  background-color: #fff!important;
  padding-right: 2em;
  background-repeat: no-repeat;
  background-position: right .5em center;
  background-image: url('~@/assets/arrow-down.svg')
}
.container-check {
  display: block;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.container-check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  height: 18px;
  width: 18px;
  @include rounded();
  @include border-dark();
  display: block;

  &.radio {
    border-radius: 50%;
  }
}

.checkmark--checked {
  border-color: #2196F3;
  background: #2196F3 url('~@/assets/check.svg') center center no-repeat;
}

.container-check .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.search-box {
  z-index: 2;
}

.disabled {
  opacity: .4;
  cursor: default;
  outline: none;
  box-shadow: none;
}
</style>
